export default [
  // EFO 落地页
  {
    path: '/activity/efocate/:componentId?',
    name:'efocate',
    meta: {
      title: 'EFO新人特惠菜',
    },
    component: () =>
      import(
        /* webpackChunkName: "activity" */
        '@/views/Activity/EFO/cate.vue'
      ),
  },
];
